/**
 * Course Dashboard Main JS
 * Logic split into component files:
 * - workspace/js/course/filters.js
 * - workspace/js/course/courses.js
 * - workspace/js/course/course-popup.js
 */
